import './NewToggle.css';

export interface NewToggleProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: React.ReactNode;
  labelClassName?: string;
}

/**
 * NewToggle — Figma-spec on/off switch (28×14 track, sliding knob). On = teal.
 * Controlled via `checked` + `onChange`; supports `disabled`. Optional label
 * renders to the right and clicking it toggles the switch.
 */
function NewToggle({ label, labelClassName, className, id, ...rest }: NewToggleProps) {
  const inputClass = ['new-toggle__input', className].filter(Boolean).join(' ');
  const labelClass = ['new-toggle__label', labelClassName].filter(Boolean).join(' ');
  return (
    <label className="new-toggle" htmlFor={id}>
      <input type="checkbox" id={id} className={inputClass} {...rest} />
      <span className="new-toggle__track" aria-hidden="true">
        <span className="new-toggle__knob" />
      </span>
      {label !== undefined ? <span className={labelClass}>{label}</span> : null}
    </label>
  );
}

export default NewToggle;
